
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import cx from 'classnames';
import { Checkbox, List, Text, LucideIcon as Icon, Link } from '../../../ui-kit';
import { ExternalLink } from 'lucide-react';
import CustomAssetPreview from './CustomAssetPreview';
import '../styles/_voice-over-list.scss';











function VoiceOverListItem({
  artist,
  handleSelectVoiceOverArtist,
  checked,
  canUpdateVideo,
  assetsMap,
  isV2Design,
  isShootstaUser = false
}) {
  const {
    artistName,
    languages,
    ageRange,
    description,
    gender,
    voiceOver,
    customThumbnail,
    artistLink
  } = artist;

  return (
    <>
      {/* $FlowFixMe */}
      <List.CardItem className="manage-voice-over__list--card">
        <div className="manage-voice-over__list--item">
          <Checkbox
            checked={checked}
            disabled={!canUpdateVideo}
            onChange={() => canUpdateVideo && handleSelectVoiceOverArtist(artist)}

            className="manage-voice-over__list--item__checkbox" />

          <div className="manage-voice-over__list--item__details">
            <CustomAssetPreview
              assetsMap={assetsMap}
              voiceOver={voiceOver}
              customThumbnail={customThumbnail}
              thumbnailWidth={70}
              thumbnailHeight={70} />

            <div className="manage-voice-over__list--item__content">
              <div className="manage-voice-over__list--item__content--top-section">
                {artistName &&
                <Text
                  label
                  noMargin
                  className={cx({ 'text-weight': isV2Design })}>

                    {artistName}
                  </Text>}

                <div className="manage-voice-over__list--item__content--top-section__right">
                  {languages &&
                  <Text
                    caption
                    noMargin
                    className={cx({ 'text-weight': isV2Design })}>

                      {languages.join(', ')}
                    </Text>}

                  {isShootstaUser &&
                  <Link onClick={() => window.open(artistLink, '_blank')}>
                      <Icon icon={ExternalLink} color="nevada" size={12} />
                    </Link>}

                </div>
              </div>
              <Text
                caption
                noMargin="bottom"
                ellipsisOverflow
                className={cx('manage-voice-over__list--item__text', {
                  'text-weight': isV2Design
                })}>

                {ageRange ? ageRange.join(', ') : ''}
                {' '}
&nbsp; &nbsp;
                {gender ? gender.join(', ') : ''}
              </Text>
              {description &&
              <div className="manage-voice-over__list--item__content--greyout">
                  <Text caption className="manage-voice-over__list--item__text">
                    {description}
                  </Text>
                </div>}

            </div>
          </div>
        </div>
      </List.CardItem>
    </>);

}

export default VoiceOverListItem;